import { encodeDeployData } from '../../utils/abi/encodeDeployData.js';
import { sendTransaction, } from './sendTransaction.js';
export function deployContract(walletClient, { abi, args, bytecode, ...request }) {
    const calldata = encodeDeployData({
        abi,
        args,
        bytecode,
    });
    return sendTransaction(walletClient, {
        ...request,
        data: calldata,
    });
}
//# sourceMappingURL=deployContract.js.map